import { Collapse, Modal, Space } from 'antd';
import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import { FAQ_DATA, TYPOGRAPHY } from '../../constants';
import { Button, Flex, TextArea, Typography } from '../common';
import { useThemeContext } from '../../theme/GlobalTheme';
import { useNavigate } from 'react-router-dom';
import { FAQ_CONFIG } from '../../constants/FAQ';

const FAQ = () => {
  const { INPUT } = FAQ_CONFIG;
  const navigate = useNavigate();
  const { isDark } = useThemeContext();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  return (
    <div className="relative h-full justify-between">
      <Flex className=" pt-10 gap-6">
        <Typography text={'Individual FAQ’s '} type={TYPOGRAPHY.TITLE} />
      </Flex>
      <Flex vertical className=" gap-10 mb-3">
        <Typography {...FAQ_DATA.title} />
      </Flex>

      {FAQ_DATA.map((section, idx) => {
        return (
          <Flex key={idx} vertical className=" gap-2  p-6">
            <Typography text={section.title} type={TYPOGRAPHY.SUBTITLE} />
            <Collapse
              accordion
              expandIconPosition="end"
              collapsible="icon"
              className="bg-[#7C30F7] text-[24px] divide-y-2 divide-white"
              bordered={false}
              expandIcon={({ isActive }) => (
                <FaPlus
                  rotate={isActive ? 90 : 0}
                  size={24}
                  className="!text-white mt-4"
                />
              )}
              items={section.faqs.map((faq, idx) => ({
                key: idx.toString(), // Ensure each key is a string
                label: <p className="!text-white text-lg">{faq.title}</p>,
                children: (
                  <Space direction="vertical" className="text-white text-lg">
                    <p>{faq.description}</p>
                  </Space>
                ),
              }))}
            />
          </Flex>
        );
      })}
      <Flex
        vertical
        justify="space-between"
        className="w-full text-white sticky bottom-0"
      >
        <Flex
          justify="end"
          className={`sticky bottom-0 w-full  lg:justify-between justify-end  p-4 border-t h-[56px] md:h-[72px] border-[#7C30F7] ${
            isDark ? 'bg-primaryDark' : 'bg-primaryLight'
          } `}
        >
          <Button
            text="Back"
            onClick={() => {
              navigate(-1);
            }}
            buttonProps={{ type: 'primary-none' }}
          />
        </Flex>
      </Flex>
      <Modal
        centered
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        closable={false}
      >
        <Flex vertical className="justify-center gap-4 p-4">
          <Typography text="Type your query here" type={TYPOGRAPHY.SUBTITLE} />
          <TextArea
            rows={6}
            {...INPUT}
            placeholder="Type something here..."
            className="bg-gray-50 cursor-text "
          />
        </Flex>
      </Modal>
    </div>
  );
};

export default FAQ;
